module.exports = __webpack_public_path__ + "img/list-bullet.32a7480d.svg";